const THUMB_PRIORITY = ['preview', 'thumb', 'thumbnail', 'poster', 'original'];
const PREVIEW_PRIORITY = ['preview', 'original', 'video', 'audio'];

export const normalize = (value) => (value || '').toLowerCase();

export const resolveThumbKind = (asset) => {
  if (!asset || asset.type === 'announcement') return null;
  if (asset.previewKind) return normalize(asset.previewKind);
  if (asset.thumbnailKind) return normalize(asset.thumbnailKind);
  const files = Array.isArray(asset.files) ? asset.files : [];
  for (const kind of THUMB_PRIORITY) {
    const found = files.find((file) => normalize(file.kind) === kind);
    if (found) return kind;
  }
  if (files.length) return normalize(files[0].kind) || 'original';
  return null;
};

export const resolvePreviewKind = (asset) => {
  if (!asset || asset.type === 'announcement') return 'original';
  if (asset.previewKind) return normalize(asset.previewKind);
  if (asset.thumbnailKind) return normalize(asset.thumbnailKind);
  const files = Array.isArray(asset.files) ? asset.files : [];
  for (const kind of PREVIEW_PRIORITY) {
    const found = files.find((file) => normalize(file.kind) === kind);
    if (found) return kind;
  }
  if (files.length) return normalize(files[0].kind) || 'original';
  return 'original';
};

export const resolvePreviewMime = (asset, kind) => {
  if (!asset) return null;
  const files = Array.isArray(asset.files) ? asset.files : [];
  if (asset.previewMime) return asset.previewMime;
  if (kind) {
    const match = files.find((file) => normalize(file.kind) === normalize(kind));
    if (match?.fileType) return match.fileType;
  }
  if (asset.thumbnailMime) return asset.thumbnailMime;
  const withType = files.find((file) => file.fileType);
  return withType?.fileType || null;
};

export const isImageAsset = (asset) => {
  if (!asset || asset.type === 'announcement') return false;
  if (asset.type === 'photo') return true;
  if (asset.content_type === 's3_image') return true;
  const kind = resolvePreviewKind(asset);
  const mime = resolvePreviewMime(asset, kind);
  if (mime) return mime.toLowerCase().startsWith('image/');
  return false;
};
